<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}故障原因
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(faultReasonEdit && formData.id != null) || (faultReasonAdd && formData.id == null)"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  故障原因编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.reasonCode" @blur="inspection" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  故障原因名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.reasonName" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  产品类型
                </th>
                <td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="formData.bigCategoryId" placeholder="大类" @change='selectOne' clearable
                               style="width: 49%!important;">
                      <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                    <el-select v-model="formData.smallCategoryId"
                               placeholder="小类"
                               @change="() => {formData.symptomList = []}"
                               @clear="() => {formData.symptomList = []}"
                               clearable
                               style="width: 49%!important;margin-left:2%;">
                      <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="formData.usable">
                    <el-option label="禁用" :value="0"/>
                    <el-option label="启用" :value="1"/>
                  </el-select>
                </td>
              </tr>

              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="d-item" style="width: 570px;">
            <div class="title first"
                 style="display: flex;flex-direction: row; justify-content: space-between;">
              <b>关联故障现象</b>
              <div class="item-button">
                <el-button type="primary" v-if="(faultReasonEdit && formData.id != null) || (faultReasonAdd && formData.id == null)" class="button-sty btn_zdy" @click="openPop">
                  <i class="el-icon-plus"></i>
                  故障现象
                </el-button>&nbsp;
                <el-button
                  type="primary" v-if="(faultReasonEdit && formData.id != null) || (faultReasonAdd && formData.id == null)" class="button-sty btn_zdy" @click="handleDeleteList">
                  <i class="el-icon-delete"></i>
                  批量删除
                </el-button>
              </div>
            </div>
            <div class="current-info">
              <vxe-table ref="filterTable" height="260"
                         class="table_item pic_item mytable-scrollbar"
                         :column-config="{ resizable: true }"
                         style="width: 100%;"
                         :stripe="true"
                         :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                         :row-config="{height: 30,isHover: true,padding: 0,}"
                         :row-style="{ fontSize: '12px',  }"
                         show-overflow
                         :data="formData.symptomList"
                         @checkbox-all="selectChangeEvent"
                         @checkbox-change="selectChangeEvent"
              >
                <vxe-column type="checkbox" width="40"/>
                <vxe-column field="symptomCode" title="故障现象编码" width="220"/>
                <vxe-column field="symptomName" title="故障现象名称" width="220"/>
                <vxe-column title="操作" width="60" v-if="(faultReasonEdit && formData.id != null) || (faultReasonAdd && formData.id == null)">
                  <template #default="{row}">
                    <div @click="handleDeleteSymptom(row.id)">
                      <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </vxe-column>
              </vxe-table>
            </div>
          </div>
        </div>

      </div>
    </el-form>

    <faultSymptomPop v-if="showPop"
                     :visiable.sync="showPop"
                     multi="true"
                     @confirm="commit"
                     :excludeIdList="excludeIdList"
                     :bigCategoryId="formData.bigCategoryId"
                     :small-category-id="formData.smallCategoryId"
    />
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import {fetchTree} from "@/api/admin/type_tree";
import api from "@/api/projectApi";
import faultSymptomPop from '@/views/dialogCommon/checkboxFaultSymptomDialog.vue'
import faultReasonPop from "@/views/dialogCommon/checkboxFaultReasonDialog.vue";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";


export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    faultReasonPop,
    Tinymce, faultSymptomPop
  },
  data() {
    return {
      faultReasonAdd: null,
      faultReasonEdit: null,
      getProductOptionUrl: '/basic/basItemCategory/getChildrens',
      dataId: '',
      productOptions0: [],
      productOptions1: [],
      formData: {
        id: null,
        reasonCode: '',  // 故障原因编码,同厂商下惟一
        reasonName: '',  // 故障原因名称
        bigCategoryId: null,  // 产品大类ID,关联bas_item_category.id
        smallCategoryId: null,  // 产品小类ID,关联bas_item_category.id,可为空
        usable: 1,  // 启用:0禁用；1启用
        createBy: '',
        createTime: '',
        symptomList: []
      },
      activeName: 'first',
      showPop: false,
      selectedIdList: null,
    };
  },

  created() {
    this.faultReasonEdit = this.permissions['fault_reason_edit']
    this.faultReasonAdd = this.permissions['fault_reason_add']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },

  computed: {
    ...mapGetters(["permissions"]),
    excludeIdList() {
      let symptomList = this.formData.symptomList;
      if (symptomList != null && symptomList.length > 0) {
        return symptomList.map(item => item.id)
      }
      return null
    }
  },

  mounted() {
    this.getData();
    this.loadProductOption0()
  },

  methods: {
    // 关联故障现象删除
    handleDeleteSymptom(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log('deleteId', id)
        let symptomList = this.formData.symptomList
        symptomList = symptomList.filter(item => item.id != id)
        this.formData.symptomList = symptomList
      })
    },

    // 关联故障现象批量删除
    handleDeleteList() {
      let selectedIdList = this.selectedIdList
      if (selectedIdList != null && selectedIdList.length > 0) {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          let symptomList = this.formData.symptomList
          console.log('deleteIdList', selectedIdList)
          console.log('symptomList', symptomList)
          selectedIdList.forEach(item => {
            symptomList = symptomList.filter(item1 => item1.id != item)
          })
          this.formData.symptomList = symptomList
        })
      } else {
        this.$message.warning('请先选中数据')
      }
    },

    // 打开弹窗
    openPop() {
      let bigCategoryId = this.formData.bigCategoryId
      if (bigCategoryId == null || bigCategoryId == '') {
        this.$message.warning('请先设置产品类型')
      } else {
        this.showPop = true
      }
    },

    // 故障现象选中
    selectChangeEvent({records}) {
      console.log(records, '选中数据')
      this.selectedIdList = records.map(item => item.id)
    },

    // 弹框选中
    commit(data) {
      console.log(data, '弹框数据')
      data.forEach(item => {
        item.isNew = true
      })
      this.formData.symptomList.push(...data)
    },

    // 故障原因编码检验
    inspection() {
      if (this.formData.reasonCode) {
        this.$http({
          url: api.basFaultReason.inspectionUrl,
          method: 'post',
          data: {
            value: this.formData.reasonCode,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("故障原因编码已存在，请重新输入")
            this.formData.reasonCode = null
          }
        })
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.basFaultReason.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let newVar = response.data.objx || {}
          if (newVar.smallCategoryId == 0) {
            newVar.smallCategoryId = ''
          }
          this.formData = newVar
          this.loadProductOption1()  // 加载产品小类用于回显
        })
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            this.$http({
              url: this.isEdit ? api.basFaultReason.updateDataUrl : api.basFaultReason.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              // this.$emit('editViewDataUpdate')
              this.goBackIndex()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          });
        }
      });
    },

    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,
        usable: 1
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 加载产品小类
    loadProductOption1() {
      fetchTree({
        categoryType: 1,
        usable: 1,
        parentId: this.formData.bigCategoryId
      }).then(response => {
        this.productOptions1 = []
        response.data.data.forEach(item => {
          this.productOptions1.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 选中产品大类加载小类
    selectOne() {
      this.formData.smallCategoryId = null
      this.loadProductOption1()

      this.formData.symptomList = []
    },



  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.btn_zdy {
  // margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
</style>
